import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
const baseClasses = 'inline-block text-center bg-green-500 hover:bg-green-400 text-black font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.4)] transition-colors duration-300';
const motionProps = {
  whileHover: {
    scale: 1.02
  },
  whileTap: {
    scale: 0.98
  }
};
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
} & (({
  href: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) | ({
  href?: undefined;
} & React.ButtonHTMLAttributes<HTMLButtonElement>));
export function Button({
  children,
  className,
  ...props
}: ButtonProps) {
  if (props.href) {
    const anchorProps = props as React.AnchorHTMLAttributes<HTMLAnchorElement>;
    return <motion.a {...motionProps} className={twMerge(baseClasses, className)} {...anchorProps} data-id="element-12" data-mp="30qqh0f3ffnbn">
        {children}
      </motion.a>;
  }
  const buttonProps = props as React.ButtonHTMLAttributes<HTMLButtonElement>;
  return <motion.button {...motionProps} className={twMerge(baseClasses, className)} {...buttonProps} data-id="element-13" data-mp="d3ta4gmt2gpe">
      {children}
    </motion.button>;
}